export enum StatusEnumModel {
  DRAFT = "Draft",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  PUBLISHED = "Published",
  PENDING_APPROVAL = "Pending Approval",
}
